export const TAG = 'CancelWithdrawalRequestDialog';
